import axios from "axios";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import { adminMainUrl } from "../../../../../../../Config";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { getCCExportConsigneeOrganisationBranchList, getCCExportOrganisationBranchList, getCCExportOrganisationList, getCCExportShipperOrganisationBranchList, getCCExportShipperOrganisationRegList } from "../../../../../../../Redux/action/CustomClearance/CCAction";

const GeneralTab = ({
    token,
    user_id,
    b64id,
    refresh,
    loadingCCImpJobDetail,
    CCImpJobDetailData,
    CCImpJobDetailDataError,
    loadingCCEmployeeList,
    employeeOptions,
    countryOptions,
    loadingCCCountryList

}) => {


    const [disableSubmit, setDisableSubmit] = useState(false);
    const dispatch = useDispatch();
    const [docsArr, setDocsArr] = useState([
        { doc_type: "BIN NO", doc_val: "" },
        { doc_type: "CIN NO", doc_val: "" },
        { doc_type: "CST NO", doc_val: "" },
        { doc_type: "ST REG NO", doc_val: "" },
        { doc_type: "TAN NO", doc_val: "" },
        { doc_type: "VAT NO", doc_val: "" },
        { doc_type: "GSTIN", doc_val: "" },
        { doc_type: "IE CODE NO", doc_val: "" },
        { doc_type: "PAN NO", doc_val: "" },
    ]);


    const {
        loadingCCExpJobOrganisationList,
        CCExpJobOrganisationListData,
        CCExpJobOrganisationListDataError,

        loadingCCExpJobShipperOrganisationBranchList,
        CCExpJobShipperOrganisationBranchListData,
        CCExpJobShipperOrganisationBranchListDataError,
        loadingCCExpJobConsigneeOrganisationBranchList,
        CCExpJobConsigneeOrganisationBranchListData,
        CCExpJobConsigneeOrganisationBranchListDataError,


        loadingCCExpJobShipperOrganisationRegList,
        CCExpJobShipperOrganisationRegListData,
        CCExpJobShipperOrganisationRegListDataError,

    } = useSelector(state => state?.CCReducer);

    useEffect(() => {
        if (user_id && token) {
            dispatch(getCCExportOrganisationList(token, user_id))
        }
    }, [user_id, token, b64id]);

    useEffect(() => {
        // console.log("CCExpJobShipperOrganisationRegListData", CCExpJobShipperOrganisationRegListData);
        if (CCExpJobShipperOrganisationRegListData) {

            const binNoObj = CCExpJobShipperOrganisationRegListData?.find(item => item.registration_type === "BIN NO");
            const binregNo = binNoObj ? binNoObj.registration_no : "";

            const cinNoObj = CCExpJobShipperOrganisationRegListData?.find(item => item.registration_type === "CIN NO");
            const cinregNo = cinNoObj ? cinNoObj.registration_no : "";

            const cstNoObj = CCExpJobShipperOrganisationRegListData?.find(item => item.registration_type === "CST NO");
            const cstregNo = cstNoObj ? cstNoObj.registration_no : "";

            const stRegNoObj = CCExpJobShipperOrganisationRegListData?.find(item => item.registration_type === "ST REG NO");
            const stRegregNo = stRegNoObj ? stRegNoObj.registration_no : "";

            const tanNoObj = CCExpJobShipperOrganisationRegListData?.find(item => item.registration_type === "TAN NO");
            const tanregNo = tanNoObj ? tanNoObj.registration_no : "";

            const vatNoObj = CCExpJobShipperOrganisationRegListData?.find(item => item.registration_type === "VAT NO");
            const vatregNo = vatNoObj ? vatNoObj.registration_no : "";

            const gstNoObj = CCExpJobShipperOrganisationRegListData?.find(item => item.registration_type === "GST NO");
            const gstregNo = gstNoObj ? gstNoObj.registration_no : "";

            const panNoObj = CCExpJobShipperOrganisationRegListData?.find(item => item.registration_type === "PAN NO");
            const panregNo = panNoObj ? panNoObj.registration_no : "";

            const ieCodeNoObj = CCExpJobShipperOrganisationRegListData?.find(item => item.registration_type === "IE CODE NO");
            const ieCoderegNo = ieCodeNoObj ? ieCodeNoObj.registration_no : "";

            setDocsArr([
                { doc_type: "BIN NO", doc_val: binregNo },
                { doc_type: "CIN NO", doc_val: cinregNo },
                { doc_type: "CST NO", doc_val: cstregNo },
                { doc_type: "ST REG NO", doc_val: stRegregNo },
                { doc_type: "TAN NO", doc_val: tanregNo },
                { doc_type: "VAT NO", doc_val: vatregNo },
                { doc_type: "GSTIN", doc_val: gstregNo },
                { doc_type: "IE CODE NO", doc_val: ieCoderegNo },
                { doc_type: "PAN NO", doc_val: panregNo },
            ]);
        }
    }, [CCExpJobShipperOrganisationRegListData])
    const resetDocs = () => {
        setDocsArr([
            { doc_type: "BIN NO", doc_val: "" },
            { doc_type: "CIN NO", doc_val: "" },
            { doc_type: "CST NO", doc_val: "" },
            { doc_type: "ST REG NO", doc_val: "" },
            { doc_type: "TAN NO", doc_val: "" },
            { doc_type: "VAT NO", doc_val: "" },
            { doc_type: "GSTIN", doc_val: "" },
            { doc_type: "IE CODE NO", doc_val: "" },
            { doc_type: "PAN NO", doc_val: "" },
        ])
    }

    // const handleDocTypeChange = (event) => {
    //     const selectedDocType = event.target.value;
    //     // Find the document matching the selected doc_type
    //     const selectedDoc = docsArr.find(doc => doc.doc_type === selectedDocType.toLowerCase().replace(/\s/g, '_'));
    //     // Set the corresponding value in 'importer_branch_regn_no'
    //     formik.setFieldValue('importer_branch_regn_no', selectedDoc ? selectedDoc.doc_val || '' : '');
    // };




    const [shipperOrganisationOptions, setShipperOrganisationOptions] = useState([]);
    const [shipperBranchOrganisationOptions, setShipperBranchOrganisationOptions] = useState([]);
    const [consigneeOrganisationOptions, setConsigneeOrganisationOptions] = useState([]);
    const [consigneeBranchOrganisationOptions, setConsigneeBranchOrganisationOptions] = useState([]);

    useEffect(() => {
        if (CCExpJobOrganisationListData) {
            let arr = [];
            CCExpJobOrganisationListData.map(val => arr.push({ value: val.id, label: val.name }));
            setShipperOrganisationOptions(arr);
            setConsigneeOrganisationOptions(arr);
        }
    }, [loadingCCExpJobOrganisationList, CCExpJobOrganisationListData]);

    useEffect(() => {
        // console.log(CCExpJobShipperOrganisationBranchListData, "===>");
        if (CCExpJobShipperOrganisationBranchListData) {
            let arr = [];
            CCExpJobShipperOrganisationBranchListData.map(val => arr.push({
                value: val.id,
                label: val.branch_name,
                branch_address: val.address_line_one + " " + val.address_line_two + " " + val.address_line_three
            }));
            setShipperBranchOrganisationOptions(arr);
        }
    }, [loadingCCExpJobShipperOrganisationBranchList, CCExpJobShipperOrganisationBranchListData]);


    useEffect(() => {
        // console.log(CCExpJobConsigneeOrganisationBranchListData, "===>");
        if (CCExpJobConsigneeOrganisationBranchListData) {
            let arr = [];
            CCExpJobConsigneeOrganisationBranchListData.map(val => arr.push({
                value: val.id,
                label: val.branch_name,
                branch_address: val.address_line_one + " " + val.address_line_two + " " + val.address_line_three,
                country_id: Number(val.country)
            }));
            setConsigneeBranchOrganisationOptions(arr);
        }
    }, [loadingCCExpJobConsigneeOrganisationBranchList, CCExpJobConsigneeOrganisationBranchListData])

    const initialValues = {
        ref_type: "",
        ref_type_number: "",
        importer_id: "",
        importer_branch_id: "",
        importer_branch_address: "",
        importer_branch_ie_code_no: "",
        importer_branch_regn_type: "",
        importer_branch_regn_no: "",
        importer_ref_no: "",
        importer_ref_date: "",
        importer_type: "",
        sb_number: "",
        sb_date: "",
        rbi_appr_no: "",
        rbi_appr_date: "",
        is_gr_waived: false,
        gr_no: "",
        gr_date: "",
        rbi_waiver_no: "",
        branch_bank_id: "",
        branch_bank_dealer: "",
        branch_account_number: "",
        consignee_id: "",
        consignee_branch_id: "",
        consignee_branch_address: "",
        consignee_branch_country: "",
        wareHouse_name: "",
        wareHouse_code: "",
        sales_person_id: "",
        business_dimensions: "",
        quotation: ""

    };

    const formik = useFormik({
        initialValues: initialValues,
        onSubmit: (values) => {
            // console.log(values);
            setDisableSubmit(true);
            try {
                let config = {
                    headers: {
                        'auth-token': token,
                        'user_id': user_id
                    }
                }

                values.custom_clearance_import_job_id = atob(b64id);
                axios.post(`${adminMainUrl}/api/customClearance/import/general/add-update`, values, config)
                    .then(response => {
                        if (response.status == 200) {
                            toast.success(response?.data?.msg);
                            setDisableSubmit(false);
                            refresh();
                        } else {
                            toast.error(response?.data?.msg);
                            setDisableSubmit(false);
                        }
                    }).catch(error => {
                        console.log(error);
                        let msg = "Internal server error!";
                        if (error.response && error.response.data && error.response.data.msg) {
                            msg = error.response.data.msg
                        }
                        toast.error(msg);
                        setDisableSubmit(false);
                    })
            } catch (error) {
                console.log(error.message);
                toast.error(error.message);
                setDisableSubmit(false);
            }
        }
    });

    useEffect(() => {
        if (formik.values.importer_branch_regn_type) {
            // console.log(formik.values.importer_branch_regn_type);
            // console.log("docsArr", docsArr);
            const selectedDoc = docsArr.find(doc => doc.doc_type == formik.values.importer_branch_regn_type);
            // console.log("selectedDoc", selectedDoc);
            // Set the corresponding value in 'importer_branch_regn_no'
            formik.setFieldValue('importer_branch_regn_no', selectedDoc ? selectedDoc.doc_val || '' : '');
        }
    }, [formik.values.importer_branch_regn_type])


    useEffect(() => {
        // console.log("CCImpJobDetailData sdfsad",CCImpJobDetailData);
        if (CCImpJobDetailData && CCImpJobDetailData?.CustomClearanceImportJobGeneral) {
            let val = CCImpJobDetailData?.CustomClearanceImportJobGeneral;
            formik.setFieldValue("ref_type", val.ref_type);
            formik.setFieldValue("ref_type_number", val.ref_type_number);
            formik.setFieldValue("importer_id", val.importer_id);
            if(val.importer_id){
                handleGetShipperBranches(val.importer_id);
            }
            formik.setFieldValue("importer_branch_id", val.importer_branch_id);
            formik.setFieldValue("importer_branch_address", val.importer_branch_address);
            formik.setFieldValue("importer_branch_ie_code_no", val.importer_branch_ie_code_no);
            formik.setFieldValue("importer_branch_regn_type", val.importer_branch_regn_type);
            formik.setFieldValue("importer_branch_regn_no", val.importer_branch_regn_no);
            formik.setFieldValue("importer_ref_no", val.importer_ref_no);
            formik.setFieldValue("importer_ref_date", val.importer_ref_date);
            formik.setFieldValue("importer_type", val.importer_type);
            formik.setFieldValue("sb_number", val.sb_number);
            formik.setFieldValue("sb_date", val.sb_date);
            formik.setFieldValue("rbi_appr_no", val.rbi_appr_no);
            formik.setFieldValue("rbi_appr_date", val.rbi_appr_date);
            formik.setFieldValue("is_gr_waived", val.is_gr_waived);
            formik.setFieldValue("gr_no", val.gr_no);
            formik.setFieldValue("gr_date", val.gr_date);
            formik.setFieldValue("rbi_waiver_no", val.rbi_waiver_no);
            formik.setFieldValue("branch_bank_id", val.branch_bank_id);
            formik.setFieldValue("branch_bank_dealer", val.branch_bank_dealer);
            formik.setFieldValue("branch_account_number", val.branch_account_number);
            formik.setFieldValue("consignee_id", val.consignee_id);
            if(val.consignee_id){
                handleGetConsigneeBranches(val.consignee_id);
            }
            formik.setFieldValue("consignee_branch_id", val.consignee_branch_id);
            formik.setFieldValue("consignee_branch_address", val.consignee_branch_address);
            formik.setFieldValue("consignee_branch_country", Number(val.consignee_branch_country));
            formik.setFieldValue("wareHouse_name", val.wareHouse_name);
            formik.setFieldValue("wareHouse_code", val.wareHouse_code);
            formik.setFieldValue("sales_person_id", Number(val.sales_person_id));
            formik.setFieldValue("business_dimensions", val.business_dimensions);
            formik.setFieldValue("quotation", val.quotation);

        }
    }, [CCImpJobDetailData]);


    const handleGetShipperBranches = (org_id) => {
        if (token && user_id && b64id && org_id) {
            dispatch(getCCExportShipperOrganisationBranchList(token, user_id, org_id));
            dispatch(getCCExportShipperOrganisationRegList(token, user_id, org_id));
        }
    };

    const handleGetConsigneeBranches = (org_id) => {
        if (token && user_id && b64id && org_id) {
            dispatch(getCCExportConsigneeOrganisationBranchList(token, user_id, org_id));
        }
    };


    return (
        <form onSubmit={formik.handleSubmit}>
            <div className="row">
                <div className="col-md-3">
                    <div className="input_box_section">
                        <label htmlFor="" className="form-label  mb-0">
                            Exporter
                        </label>
                        <div className="icon-forms mb-3 mb-sm-0">
                            <Select
                                className="custom-selector"
                                placeholder="Select Organisation"
                                name="importer_id"
                                options={shipperOrganisationOptions}
                                onChange={option => {
                                    //reset the branches
                                    setShipperBranchOrganisationOptions([]);
                                    formik.setFieldValue('importer_branch_id', "");
                                    formik.setFieldValue('importer_branch_regn_type', "");
                                    formik.setFieldValue('importer_branch_regn_no', "");
                                    //set values and change branches
                                    formik.setFieldValue('importer_id', option.value);
                                    handleGetShipperBranches(option.value);
                                }}
                                value={shipperOrganisationOptions.find(option => option.value === formik.values.importer_id) || null}
                            />
                        </div>
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="input_box_section">
                        <label htmlFor="" className="form-label  mb-0">
                            Branch
                        </label>
                        <div className="icon-forms mb-3 mb-sm-0">
                            <Select
                                className="custom-selector "
                                placeholder="Select Branch"
                                name="importer_branch_id"
                                options={shipperBranchOrganisationOptions}
                                onChange={option => {
                                    formik.setFieldValue('importer_branch_address', "")
                                    formik.setFieldValue('importer_branch_id', option.value);
                                    formik.setFieldValue('importer_branch_address', option.branch_address)
                                }}
                                value={shipperBranchOrganisationOptions.find(option => option.value === formik.values.importer_branch_id) || null}
                            />
                        </div>
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="input_box_section">
                        <label htmlFor="" className="form-label  mb-0">
                            Exporter Branch Address
                        </label>
                        <div className="icon-forms mb-3 mb-sm-0">
                            <input
                                type="text"
                                name="importer_branch_address"
                                className="form-control form-control-sm"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.importer_branch_address}
                            />
                        </div>
                    </div>
                </div>

                <div className="col-md-3">
                    <div className="input_box_section">
                        <label htmlFor="" className="form-label  mb-0">
                            IE Code No
                        </label>
                        <div className="icon-forms mb-3 mb-sm-0">
                            <input
                                type="text"
                                className="form-control form-control-sm"
                                name="importer_branch_ie_code_no"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.importer_branch_ie_code_no}
                            />
                        </div>
                    </div>
                </div>

                <div className="col-md-6">
                    <div className="input_box_section">
                        <label htmlFor="" className="form-label  mb-0">
                            Regn. No
                        </label>
                        <div className="icon-forms d-flex gap-3 mb-3 mb-sm-0">
                            {/* <Select className="custom-selector " /> */}
                            <select className="form-control form-control-sm"
                                name="importer_branch_regn_type"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.importer_branch_regn_type}
                            >
                                <option value="" disabled>-</option>
                                <option value="BIN NO">BIN NO</option>
                                <option value="CIN NO">CIN NO</option>
                                <option value="CST NO">CST NO</option>
                                <option value="ST REG NO">ST REG NO</option>
                                <option value="TAN NO">TAN NO</option>
                                <option value="VAT NO">VAT NO</option>
                                <option value="GSTIN">GSTIN</option>
                                <option value="IE CODE NO">IE CODE NO</option>
                                <option value="PAN NO">PAN NO</option>
                            </select>
                            <input
                                type="text"
                                className="form-control form-control-sm"
                                name="importer_branch_regn_no"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.importer_branch_regn_no}
                            />
                        </div>
                    </div>
                </div>


                <div className="col-md-3">
                    <div className="input_box_section">
                        <label htmlFor="" className="form-label  mb-0">
                            Exporter Ref No.
                        </label>
                        <input
                            type="text"
                            className="form-control form-control-sm"
                            name="importer_ref_no"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.importer_ref_no} />
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="input_box_section">
                        <label htmlFor="" className="form-label  mb-0">
                            Exporter Ref Date
                        </label>
                        <input
                            type="date"
                            className="form-control form-control-sm"
                            name="importer_ref_date"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.importer_ref_date}
                        />
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="input_box_section">
                        <label htmlFor="" className="form-label  mb-0">
                            Exporter Type
                        </label>
                        <select
                            className="form-control form-control-sm"

                            name="importer_type"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.importer_type}

                        >
                            <option value="" disabled>-</option>
                            <option value="Manufacturer Exporter">Manufacturer Exporter</option>
                            <option value="Merchant Exporter">Merchant Exporter</option>
                            <option value="Other">Other</option>
                        </select>
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="input_box_section">
                        <label htmlFor="" className="form-label  mb-0">
                            Ref Type
                        </label>
                        <select
                            className="form-control form-control-sm"

                            name="ref_type"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.ref_type}

                        >
                            <option value="" disabled>-</option>
                            <option value="Job Order">Job Order</option>
                            <option value="Shipment">Shipment</option>
                        </select>
                    </div>
                </div>

                <div className="col-md-3">
                    <div className="input_box_section">
                        <label htmlFor="" className="form-label  mb-0">
                            Ref No.
                        </label>
                        <div className="icon-forms mb-3 mb-sm-0">
                            <input
                                type="text"
                                className="form-control form-control-sm"
                                maxLength={250}
                                name="ref_type_number"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.ref_type_number}
                            />
                        </div>
                    </div>
                </div>
                <div className="col-md-3"></div>
                <div className="col-md-3">
                    <div className="input_box_section">
                        <label htmlFor="" className="form-label  mb-0">
                            Consignee
                        </label>
                        <div className="icon-forms mb-3 mb-sm-0">
                            <Select
                                className="custom-selector"
                                placeholder="Select Organisation"
                                name="consignee_id"
                                options={consigneeOrganisationOptions}
                                onChange={option => {
                                    //reset the branches
                                    setConsigneeBranchOrganisationOptions([]);
                                    formik.setFieldValue('consignee_branch_id', "");
                                    //set values and change branches
                                    formik.setFieldValue('consignee_id', option.value);
                                    handleGetConsigneeBranches(option.value);
                                }}
                                value={consigneeOrganisationOptions.find(option => option.value === formik.values.consignee_id) || null}
                            />
                        </div>
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="input_box_section">
                        <label htmlFor="" className="form-label  mb-0">
                            Consginee Branch
                        </label>
                        <div className="icon-forms mb-3 mb-sm-0">
                            <Select
                                className="custom-selector "
                                placeholder="Select Branch"
                                name="consignee_branch_id"
                                options={consigneeBranchOrganisationOptions}
                                onChange={option => {
                                    formik.setFieldValue('consignee_branch_address', "")
                                    formik.setFieldValue('consignee_branch_country', "")
                                    formik.setFieldValue('consignee_branch_id', option.value);
                                    formik.setFieldValue('consignee_branch_address', option.branch_address)
                                    formik.setFieldValue('consignee_branch_country', option.country_id)
                                }}
                                value={consigneeBranchOrganisationOptions.find(option => option.value === formik.values.consignee_branch_id) || null}
                            />
                        </div>
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="input_box_section">
                        <label htmlFor="" className="form-label  mb-0">
                            Consignee Branch Address
                        </label>
                        <div className="icon-forms mb-3 mb-sm-0">
                            <input
                                type="text"
                                className="form-control form-control-sm"
                                id="consignee_branch_address"
                                name="consignee_branch_address"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.consignee_branch_address}
                            />
                        </div>
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="input_box_section">
                        <label htmlFor="" className="form-label  mb-0">
                            Consignee Branch Country
                        </label>
                        <div className="icon-forms mb-3 mb-sm-0">
                            <Select
                                className="custom-selector "
                                placeholder="Select Country"
                                name="consignee_branch_country"
                                options={countryOptions}
                                onChange={option => {
                                    formik.setFieldValue('consignee_branch_country', option.value);
                                }}
                                value={countryOptions.find(option => option.value === formik.values.consignee_branch_country) || null}
                                isLoading={loadingCCCountryList}
                            />
                        </div>
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="input_box_section">
                        <label htmlFor="" className="form-label  mb-0">
                            SB Number
                        </label>
                        <input type="text"
                            maxLength={250}
                            className="form-control form-control-sm"
                            name="sb_number"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.sb_number}
                        />
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="input_box_section">
                        <label htmlFor="" className="form-label  mb-0">
                            SB Date
                        </label>
                        <input type="date"
                            className="form-control form-control-sm"
                            name="sb_date"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.sb_date} />
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="input_box_section">
                        <label htmlFor="" className="form-label  mb-0">
                            RBI Appr. No
                        </label>
                        <input type="text" className="form-control form-control-sm"
                            maxLength={250}
                            name="rbi_appr_no"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.rbi_appr_no} />
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="input_box_section">
                        <label htmlFor="" className="form-label  mb-0">
                            RBI Appr. Date
                        </label>
                        <input type="date"
                            className="form-control form-control-sm"
                            name="rbi_appr_date"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.rbi_appr_date}
                        />
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="input_box_section">
                        <label htmlFor="" className="form-label  mb-0">
                            GR Waived
                        </label>
                        <input type="checkbox"
                            className="ms-2"
                            name="is_gr_waived"
                            onChange={(event) => {
                                formik.setFieldValue('is_gr_waived', event.target.checked)
                            }}
                            checked={formik.values.is_gr_waived}
                        />
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="input_box_section">
                        <label htmlFor="" className="form-label  mb-0">
                            GR No
                        </label>
                        <input type="text" className="form-control form-control-sm"
                            maxLength={250}
                            name="gr_no"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.gr_no}
                        />
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="input_box_section">
                        <label htmlFor="" className="form-label  mb-0">
                            GR Date
                        </label>
                        <input type="date" className="form-control form-control-sm"
                            name="gr_date"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.gr_date}
                        />
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="input_box_section">
                        <label htmlFor="" className="form-label  mb-0">
                            RBI Waiver No
                        </label>
                        <input type="text" className="form-control form-control-sm"
                            name="rbi_waiver_no"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.rbi_waiver_no}
                        />
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="input_box_section">
                        <label htmlFor="" className="form-label  mb-0">
                            RBI Waiver Date
                        </label>
                        <input type="date" className="form-control form-control-sm" />
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="input_box_section">
                        <label htmlFor="" className="form-label  mb-0">
                            Bank / Dealer
                        </label>
                        <input type="text" className="form-control form-control-sm"
                            name="branch_bank_dealer"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.branch_bank_dealer}
                        />
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="input_box_section">
                        <label htmlFor="" className="form-label  mb-0">
                            A/C Number
                        </label>
                        <input type="text" className="form-control form-control-sm"
                            name="branch_account_number"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.branch_account_number}
                        />
                    </div>
                </div>

                <div className="col-md-3">
                    <div className="input_box_section">
                        <label htmlFor="" className="form-label  mb-0">
                            Sales Person
                        </label>
                        <Select
                            className="custom-selector "
                            placeholder="Select Sales Person"
                            name="sales_person_id"
                            options={employeeOptions}
                            onChange={option => {
                                formik.setFieldValue('sales_person_id', option.value);
                            }}
                            value={employeeOptions.find(option => option.value === formik.values.sales_person_id) || null}
                            isLoading={loadingCCEmployeeList}
                        />
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="input_box_section">
                        <label htmlFor="" className="form-label  mb-0">
                            Business Dimensions
                        </label>
                        <input
                            className="form-control form-control-sm"
                            name="business_dimensions"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.business_dimensions}
                        />
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="input_box_section">
                        <label htmlFor="" className="form-label  mb-0">
                            Warehouse Name
                        </label>
                        <input
                            className="form-control form-control-sm"
                            name="wareHouse_name"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.wareHouse_name}
                        />
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="input_box_section">
                        <label htmlFor="" className="form-label  mb-0">
                            Warehouse Code
                        </label>
                        <input
                            className="form-control form-control-sm"
                            name="wareHouse_code"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.wareHouse_code}
                        />
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="input_box_section">
                        <label htmlFor="" className="form-label  mb-0">
                            Quotation
                        </label>
                        <input type="text"
                            className="form-control form-control-sm"
                            name="quotation"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.quotation}
                        />
                    </div>
                </div>
                <div className="row d-flex justify-content-end mt-2">
                    <div className="col-md-6 d-flex justify-content-end">
                        <button type="submit" className="btn btn-sm btn-danger" disabled={disableSubmit}>
                            {disableSubmit ? <><i className="fas fa-spinner fa-spin"></i> Saving...</> : "Update"}
                        </button>
                    </div>
                </div>

            </div>
        </form>
    );
};

export default GeneralTab;
